import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path:'/self',
    name:'self',
    component:()=>import('../views/self.vue'),
    beforeEnter(to,from,next){
      console.log(to,from,window)
      window.scrollTo(0,0)
      next();
    }
  },
  {
    path: '/about',
    name: 'About',
    redirect: '/company1',
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue'),
    // beforeEnter(to,from,next){
    //   console.log(to,from)
    //   // let obj = {
    //   //   0:'company1',
    //   //   1:'company2',
    //   //   2:'company3',
    //   //   3:'company4',
    //   // }
    //   // let i = sessionStorage.getItem('activeIndex1');
    //   // i = i?i:0;
    //   // console.log(sessionStorage.getItem('activeIndex1'))
    //   // next({name:obj[i]});
    //   next();
    // },
    children: [
      {
        path: '/company1',
        name: 'company1',
        component: () => import(/* webpackChunkName: "about" */ '../components/about/company1.vue')
      },
      {
        path: '/company2',
        name: 'company2',
        component: () => import('../components/about/company2.vue')
      },
      {
        path: '/company3',
        name: 'company3',
        component: () => import('../components/about/company3.vue')
      },
      {
        path: '/company4',
        name: 'company4',
        component: () => import('../components/about/company4.vue')
      },
      {
        path: '/product1',
        name: 'product1',
        component: () => import('../components/about/product1.vue')
      },
      {
        path: '/product2',
        name: 'product2',
        component: () => import('../components/about/product2.vue')
      },
      {
        path: '/product3',
        name: 'product3',
        component: () => import('../components/about/product3.vue')
      },
      {
        path: '/product4',
        name: 'product4',
        component: () => import('../components/about/product4.vue')
      },
      {
        path: '/product5',
        name: 'product5',
        component: () => import('../components/about/product5.vue')
      },
    ]
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/product.vue')
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('../views/cooperation.vue')
  },
  {
    path: '/job',
    name: 'Job',
    component: () => import('../views/job.vue')
  }

]

const router = new VueRouter({
  routes
})

export default router
